import { useState } from "react";
import { toast } from "sonner";
import { MailWarning, RotateCw, Settings2 } from "lucide-react";
import { http, formatApiError } from "../lib/api";

export const MailAlertBanner = ({ alert, onDone, onOpen }) => {
  const [busy, setBusy] = useState(false);
  const resend = async () => {
    setBusy(true);
    try {
      const { data } = await http.post("/superadmin/mail-log/resend-failed");
      if (!data.total) toast.info("Aucun e-mail à renvoyer");
      else if (!data.failed) toast.success(`${data.sent} e-mail${data.sent > 1 ? "s" : ""} renvoyé${data.sent > 1 ? "s" : ""}`);
      else toast.error(`${data.failed} e-mail(s) toujours en échec${data.reason ? ` : ${data.reason}` : ""}`);
      onDone();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="mail-alert-banner" className="flex flex-wrap items-start gap-3 bg-rose-600 text-white rounded-md px-5 py-4">
      <MailWarning className="h-6 w-6 shrink-0 mt-0.5" />
      <span className="flex-1 min-w-[260px]">
        <b className="block" data-testid="mail-alert-count">{alert.count} e-mail{alert.count > 1 ? "s" : ""} XALTIX refusé{alert.count > 1 ? "s" : ""} par la boîte d'envoi — le dernier le {new Date(alert.last_at).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" })}</b>
        <span className="block text-sm text-white/90" data-testid="mail-alert-reason">Raison : {alert.last_reason || "inconnue"}</span>
        <span className="block text-xs text-white/75 mt-0.5">Dernier : « {alert.last_subject} » à {alert.last_to}</span>
      </span>
      <div className="flex gap-2">
        <button type="button" onClick={resend} disabled={busy} className="inline-flex items-center gap-1.5 bg-white text-rose-700 px-4 py-2 rounded-full text-sm font-bold hover:bg-rose-50 transition-colors disabled:opacity-60" data-testid="mail-alert-resend-btn"><RotateCw className={`h-4 w-4 ${busy ? "animate-spin" : ""}`} />{busy ? "Renvoi…" : "Renvoyer"}</button>
        <button type="button" onClick={onOpen} className="inline-flex items-center gap-1.5 border border-white/60 px-4 py-2 rounded-full text-sm font-semibold hover:bg-white/10 transition-colors" data-testid="mail-alert-open-settings"><Settings2 className="h-4 w-4" />Boîte d'envoi</button>
      </div>
    </div>
  );
};
